import React, { useState } from 'react';

import style from './HoverDropdown.module.scss';

export interface HoverDropdownItem {
    key: string;
    content: React.ReactNode;
    onClick: () => void;
}

interface HoverDropdownProps {
    items: HoverDropdownItem[];
    children: React.ReactNode;
    className?: string;
}

export const HoverDropdown = ({ items, children, className }: HoverDropdownProps) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            className={style.dropdown}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className={className}>{children}</div>
            {isHovered && (
                <div className={style.menu}>
                    <div className={style.menuList}>
                        {items.map(item => (
                            <div
                                className={style.menuItem}
                                key={item.key}
                                onClick={item.onClick}
                            >
                                {item.content}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
